<template>
  <DashboardCard>
    <WdsStack direction-row gap-lg>
      <WdsButtonGhost
        v-for="metric in metrics"
        :key="metric.label"
        :href="metric.url"
        align-center
        direction-column
        class="tw-flex tw-flex-col tw-items-center tw-flex-1 tw-flex-grow tw-gap-2 tw-mb-4"
      >
        <WdsText>
          <template #default>
            <div class="tw-text-base tw-font-normal tw-font-sans">{{ metric.label }}</div>
          </template>
        </WdsText>
        <div class="tw-p-2">
          <Skeleton v-if="loading" class="tw-rounded tw-h-[50px] tw-w-[50px]" />
          <WdsText v-else>
            <template #default>
              <div class="tw-text-4xl tw-font-normal tw-font-display">
                {{ metric.value }}
              </div>
            </template>
          </WdsText>
        </div>
      </WdsButtonGhost>
    </WdsStack>
  </DashboardCard>
</template>

<script setup lang="ts">
import { WdsButtonGhost, WdsStack, WdsText } from '@worksome/wds-components'

import DashboardCard from '@/components/Dashboard/DashboardCard.vue'
import Skeleton from '@/components/Dashboard/Widgets/Utils/Skeleton.vue'

export interface DashboardMetric {
  label: string
  value: number
  url: string
}

defineProps<{
  metrics: DashboardMetric[]
  loading: boolean
}>()
</script>

<style lang="scss" scoped>
:deep(.wds-menu) {
  @apply tw-w-[200px];
}

:deep(.wds-menu-option-content) {
  @apply tw-w-full;
}
</style>
